// const breakPoint = 767;
// let resizeFlag   = false;
// let windowWidth  = window.innerWidth;
// let windowHeight = window.innerHeight;
// let windowWidthJ = $(window).width();



// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};


// ------------------------------------------------------------------------
// showContents
// ----- BOTH
// ------------------------------------------------------------------------
const showContents = () => {

  /*----------------------------------
  onLoadImg
  ----------------------------------*/
  $(window).on('load', function(){

      $('#st-Loading').addClass("load");

      setTimeout(function(){
        $('#st-Loading').remove();
      },2200);

      setTimeout(function(){
        $('.band').addClass("load");
      },1800);


  });//load



};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  // $("a[href^=#]").on("click", function(){
  //   var linkSpeed    = 800;
  //   var linkHref     = $(this).attr("href");
  //   var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
  //   var linkAdjust   = 0;
  //   var linkPosition = linkTarget.offset().top;
  //   $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
  //   return false;
  // });
};

// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {

  let headerFlag        = false;
  let stHeader  = document.getElementById('st-Header');
  // let stHeaderNav  = document.getElementById('st-Header_Navi');
  let headerButton  = document.getElementById('st-Menu');

  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      $('#st-Header_Navi').css({'display':'block'});
      setTimeout(function(){
        stHeader.classList.remove('closed');
        stHeader.classList.add('opend');
        headerFlag = true;
  		},200);
    }else{
      stHeader.classList.remove('opend');
      stHeader.classList.add('closed');
      headerFlag = false;
      setTimeout(function(){
        $('#st-Header_Navi').css({'display':'none'});
  		},200);
    }
  }, false);


  // スクロールで縮める
  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
      if(scrollPosition >= 50){
        $("#st-Header").addClass('st-Header-Shorten');
      } else {
        $("#st-Header").removeClass('st-Header-Shorten');
      }
  });





};

// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {


  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
    // if(windowW >= 768){
      if(scrollPosition >= 50){
        $("#st-Pagetop").removeClass('st-Pagetop-Hidden');
      } else {
        $("#st-Pagetop").addClass('st-Pagetop-Hidden');
      }
    // }
  });

  $("#st-Pagetop").on("click", function(){
    var linkSpeed    = 500;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "swing");
    return false;
  });

};


// ------------------------------------------------------------------------
// setParticle
// ----- BOTH
// ------------------------------------------------------------------------
const setParticle = () => {

  //setParticle
  setParticle();

  function setParticle() {
    particlesJS("index-About_Particles", {
      particles: {

        //=== シェイプの設定 =====
        number: {
          value: 140,//シェイプ数
          density: {
            enable: true,//シェイプの密集度を変更するか否か
            value_area: 5000//シェイプの密集度
          }
        },
        color: { value: "#adfeff" },//シェイプの色
        shape: {
          type: "polygon",//シェイプの形（circle:丸、edge:四角、triangle:三角、polygon:多角形、star:星型、image:画像）
          stroke: {
            width: 0,//シェイプの外線の太さ
            color: "#adfeff"//シェイプの外線の色
          },
          polygon: { nb_sides: 5 }//typeをpolygonにした時の多角形の角の数
        },
        opacity: {
          value: 0.4,//シェイプの透明度
          random: true,//シェイプの透明度をランダムにするか否か
          anim: {
            enable: false,//シェイプの透明度をアニメーションさせるか否か
            speed: 10,//アニメーションのスピード
            opacity_min: 0.05,//透明度の最小値
            sync: false//全てのシェイプを同時にアニメーションさせるか否か
          }
        },
        size: {
          value: 3,//シェイプの大きさ
          random: true,//シェイプの大きさをランダムにするか否か
          anim: {
            enable: false,//シェイプの大きさをアニメーションさせるか否か
            speed: 40,//アニメーションのスピード
            size_min: 0,//大きさの最小値
            sync: false//全てのシェイプを同時にアニメーションさせるか否か
          }
        },

        //=== 線の設定 =====
        line_linked: {
          enable: true,//線を表示するか否か
          distance: 200,//線をつなぐシェイプの間隔
          color: "#adfeff",//線の色
          opacity: 0.5,//線の透明度
          width: 1//線の太さ
        },

        //=== 動きの設定 =====
        move: {
          enable: true,
          speed: 6,//7.8914764163227265,//シェイプの動くスピード
          direction: "none", //エリア全体の動き(none、top、top-right、right、bottom-right、bottom、bottom-left、left、top-leftより選択)
          random: true,
          straight: false,//個々のシェイプの動きを止めるか否か
          out_mode: "out",//エリア外に出たシェイプの動き(out、bounceより選択)
          bounce: false,
          attract: { enable: false, rotateX: 600, rotateY: 1200 }
        }
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: { enable: false, mode: "bubble" },
          onclick: { enable: false, mode: "repulse" },
          resize: true
        },
        modes: {
          grab: { distance: 400, line_linked: { opacity: 0.5 } },
          bubble: { distance: 800, size: 4, duration: 0.3, opacity: 1, speed: 3 },
          repulse: { distance: 200, duration: 0.4 },
          push: { particles_nb: 4 },
          remove: { particles_nb: 2 }
        }
      },
      retina_detect: true//Retina Displayを対応するか否か
    });
  }

};


// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#movie-Stage');
  const $content = $('#movie-Iframe');


  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){


      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;

  	});


  });
  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children('iframe').remove();
		});
    //
    // $modal.stop().fadeOut(300, function(){
    //   $content.children('iframe').remove();
    // });
  });

};


// ------------------------------------------------------------------------
// navCurrent
// ----- BOTH
// ------------------------------------------------------------------------
const navCurrent = () => {

  navInit();

  function navInit() {

      const CONTENTS_ARR = ['home', 'about','system','movie'];
      const SYSTEM_ARR = ['character', 'gun','wire','tracker'];
      const __contents = $('.st-Container').attr('data-name');
      const __layer = $('.st-Container').attr('data-layer');

      //_contentsがCONTENTS_ARRの何番目か。
      var _currentNum = $.inArray(__contents, CONTENTS_ARR);
      var _currentSubNum = $.inArray(__layer, SYSTEM_ARR);


      if( __layer == 'third') {

        _currentNum = 2;

        if(__contents == 'character') {
          _currentSubNum = 0;
        } else if(__contents == 'gun') {
          _currentSubNum = 1;
        } else if(__contents == 'wire') {
          _currentSubNum = 2;
        } else if(__contents == 'tracker') {
          _currentSubNum = 3;
        }

        $('.sub-Item').removeClass('current').eq(_currentSubNum).addClass('current');
        $('.nav-Item').removeClass('current').eq(_currentNum).addClass('third');

        return false;


      } else if(__contents == 'home') {
        _currentNum = 0;
      } else if(__contents == 'about') {
        _currentNum = 1;
      } else if(__contents == 'system') {
        _currentNum = 2;
      } else if(__contents == 'movie') {
        _currentNum = 3;
      }

      $('.nav-Item').removeClass('current').eq(_currentNum).addClass('current');

  }
};


export {
  preload,
  showContents,
  anchorLink,
  toggleHeader,
  pageTop,
  setParticle,
  showMovie,
  navCurrent
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js